import type { InvoiceDispute, InvoiceDisputeDisplayState } from '@/shared/domain'
import { Badge } from '@/shared/ui/primitives'

export type InvoiceDisputeBadgeProps = {
  dispute?: InvoiceDispute
}

type BadgeMeta = {
  label: string
  variant: 'success' | 'destructive' | 'secondary'
}

const DISPUTE_META: Record<InvoiceDisputeDisplayState, BadgeMeta> = {
  open: { label: 'Disputed', variant: 'destructive' },
  under_review: { label: 'Disputed', variant: 'destructive' },
  won: { label: 'Dispute won', variant: 'success' },
  lost: { label: 'Dispute lost', variant: 'destructive' },
  closed: { label: 'Dispute closed', variant: 'secondary' },
}

export function InvoiceDisputeBadge({ dispute }: InvoiceDisputeBadgeProps) {
  if (!dispute) return null

  const meta = DISPUTE_META[dispute.displayState]

  return (
    <Badge variant={meta.variant} className="text-2xs">
      {meta.label}
    </Badge>
  )
}
